import '../App.css';
import { useState } from "react";
import { Allotment } from "allotment";
import "allotment/dist/style.css";
import { FONT_FAMILY, COLORS } from "../theme";
import Navbar from "../components/Navbar";

const NAVBAR_HEIGHT = 100;

export default function HelloWorldPage() {
    const [verticalSizes, setVerticalSizes] = useState([250, 750]); // left, right
    const [horizontalSizes, setHorizontalSizes] = useState([800, 200]); // top, bottom right

    // Dummy state for navbar compatibility
    const [errorLeft] = useState(false);
    const [errorRight] = useState(false);
    const [bucketPathInput] = useState("");
    const [bucketPathInput2] = useState("");

    return (
        <div style={{ width: "100vw", height: "100vh", position: "relative" }}>
            {/* Top Navbar/Header - always fixed at the top */}
            <Navbar
                errorLeft={errorLeft}
                errorRight={errorRight}
                bucketPathInput={bucketPathInput}
                bucketPathInput2={bucketPathInput2}
                FONT_FAMILY={FONT_FAMILY}
                COLORS={COLORS}
            />
            {/* Main content below navbar, absolutely positioned */}
            <div
                style={{
                    position: "absolute",
                    top: NAVBAR_HEIGHT,
                    left: 0,
                    width: "100vw",
                    height: `calc(100vh - ${NAVBAR_HEIGHT}px)`,
                    overflow: "hidden"
                }}
            >
                <Allotment
                    defaultSizes={verticalSizes}
                    onChange={setVerticalSizes}
                >
                    {/* Left Pane: Full vertical height */}
                    <div style={{
                        height: "100%",
                        background: COLORS.leftPane,
                        color: COLORS.text,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        paddingTop: 40,
                        fontFamily: FONT_FAMILY,
                        position: 'relative',
                        overflow: 'auto'
                    }}>
                        <div style={{
                            fontSize: 48,
                            fontWeight: 700,
                            marginBottom: 24,
                            letterSpacing: 1.2,
                            fontFamily: FONT_FAMILY,
                            textAlign: 'center'
                        }}>
                            Hello World! 👋
                        </div>

                        <div style={{
                            fontSize: 18,
                            color: COLORS.accent,
                            marginBottom: 32,
                            textAlign: 'center',
                            maxWidth: '80%'
                        }}>
                            Welcome to the new dashboard app! This is a simple hello world page built with the same styling and structure as the main SunPDE Model app.
                        </div>

                        <div style={{
                            background: COLORS.boxBackground,
                            padding: '20px',
                            borderRadius: '8px',
                            boxShadow: COLORS.boxShadow,
                            maxWidth: '80%'
                        }}>
                            <h3 style={{
                                margin: '0 0 16px 0',
                                color: COLORS.accent,
                                fontSize: 20
                            }}>
                                Features:
                            </h3>
                            <ul style={{
                                margin: 0,
                                paddingLeft: '20px',
                                color: COLORS.text,
                                fontSize: 16,
                                lineHeight: '1.6'
                            }}>
                                <li>Same visual styling as the main app</li>
                                <li>Responsive layout with Allotment</li>
                                <li>Consistent theme and colors</li>
                                <li>Ready for your custom content!</li>
                            </ul>
                        </div>
                    </div>

                    {/* Right: Two horizontal panes */}
                    <Allotment vertical defaultSizes={horizontalSizes} onChange={setHorizontalSizes}>
                        {/* Top right pane */}
                        <div style={{
                            width: "100%",
                            height: "100%",
                            background: COLORS.topRightPane,
                            color: COLORS.text,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontFamily: FONT_FAMILY,
                            flexDirection: "column"
                        }}>
                            <div style={{
                                fontSize: 24,
                                fontWeight: 600,
                                marginBottom: 16,
                                color: COLORS.accent
                            }}>
                                Top Right Pane
                            </div>
                            <div style={{
                                fontSize: 16,
                                color: COLORS.text,
                                textAlign: 'center',
                                maxWidth: '80%'
                            }}>
                                This space could contain charts, visualizations, or other interactive content.
                            </div>
                        </div>

                        {/* Bottom right pane */}
                        <div style={{
                            width: "100%",
                            background: COLORS.bottomRightPane,
                            color: COLORS.text,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            paddingLeft: 20,
                            paddingTop: 20,
                            fontFamily: FONT_FAMILY,
                            flexDirection: "column",
                            height: "100%"
                        }}>
                            <div style={{
                                fontSize: 24,
                                fontWeight: 600,
                                marginBottom: 16,
                                color: COLORS.accent
                            }}>
                                Bottom Right Pane
                            </div>
                            <div style={{
                                fontSize: 16,
                                color: COLORS.text,
                                textAlign: 'center',
                                maxWidth: '80%'
                            }}>
                                This area could be used for controls, settings, or additional information.
                            </div>
                        </div>
                    </Allotment>
                </Allotment>
            </div>
        </div>
    );
} 